/** Site-wide copy in Arabic. Mirrors `../en/site.js` key for key. */
import { GET_STARTED_URL, SIGN_IN_URL } from '@/data/links'

export const SITE_NAME = 'MeetNPlan'
export const SITE_TAGLINE = 'الاجتماعات والقاعات والزوار للمكاتب الحديثة.'

export const ACTIONS = {
  signIn: { label: 'تسجيل الدخول', href: SIGN_IN_URL },
  demo: { label: 'احجز عرضًا تجريبيًا', href: '/contact' },
  start: { label: 'ابدأ تجربة مجانية', href: GET_STARTED_URL },
}
